<template>
  <section
    v-if="codProducao && producao"
    class="wrapper"
    :class="isFullScreen ? 'justify-center align-center' : ''"
    :key="isVertical"
    :style="getBackgroundColor()"
  >
    <transition
      name="danca-huck-tarja"
      :duration="hasTarjaLeaveAnimation ? { enter: 0, leave: 600 } : 0"
    >
      <div v-if="mountTarja && viewMode === 'Midia'" style="width: 100%" class="tarjaRow">
        <component
          v-for="card in this.cardOnView"
          :key="card.id"
          v-bind:is="card.component"
          v-bind="card.options"
        />
      </div>
    </transition>
    <div
      v-if="mountTarja && viewMode === 'Cronometro'"
      style="width: 100%"
      class="tarjaRow"
    >
      <CardTarjaCronometro
        :cronometro-data="cronometroData"
        :cor-texto="cronometroData.config_tarja_cronometro.dsc_hex_cor_texto"
        :background-card="cronometroData.config_tarja_cronometro.dsc_hex_background_card"
        :cor-borda="cronometroData.config_tarja_cronometro.dsc_hex_cor_borda_card"
        :cor-texto-last-ten-seconds="
          cronometroData.config_tarja_cronometro.dsc_hex_cor_texto_last_ten_seconds
        "
        :cor-texto-cronometro-zerado="
          cronometroData.config_tarja_cronometro.dsc_hex_cor_texto_cronometro_zerado
        "
        :posicao-card="posicaoCardTarja"
        :show-timeout-text="cronometroData.config_tarja_cronometro.flg_show_timeout_text"
      />
    </div>
    <div
      v-else-if="mountTarja && viewMode === 'Camera'"
      style="width: 100%; height: 100%"
      class="tarjaRow"
    >
      <div v-if="cameraData" style="width: 100%; height: 100vh">
        <HlsVideoPlayer
          :src="cameraData.camera.streaming_url"
          :id="cameraData.camera.id"
          :controls="false"
        />
      </div>
    </div>
  </section>
</template>

<script>
import CardTarjaDefault from "@/components/Cards/midias/Tarjas/CardTarjaDefault.vue";
import CardTarjaHexaNeles from "@/components/Cards/midias/Tarjas/CardTarjaHexaNeles.vue";
import CardTarjaRadarCopa from "@/components/Cards/midias/Tarjas/CardTarjaRadarCopa.vue";
import CardTarjaVoceDecide from "@/components/Cards/midias/Tarjas/CardTarjaVoceDecide.vue";
import CardPanelaco from "@/components/Cards/CardPanelaco.vue";
import CardTarjaDefaultTwitter from "@/components/Cards/midias/Tarjas/CardTarjaDefaultTwitter.vue";
import CardTarjaPapoDeSegunda from "@/components/Cards/CardTarjaPapoDeSegunda.vue";
import CardTarjaPapoDeSegundaV2 from "@/components/Cards/CardTarjaPapoDeSegundaV2.vue";
import CardTacaDasFavelas from "@/components/Cards/CardTacaDasFavelas.vue";
import CardTarjaMundialDeClubesFifa from "@/components/Cards/CardTarjaMundialDeClubesFifa.vue";
import CardSaoSilvestre from "@/components/Cards/CardSaoSilvestre.vue";
import CardTarjaMesacast from "@/components/Cards/CardTarjaMesacast.vue";
import CardTarjaTwitterBBB from "@/components/Cards/CardTarjaTwitterBBB.vue";
import CardTarjaBBBEliminacao from "@/components/Cards/CardTarjaBBBEliminacao.vue";
import CardTarjaQHEEP from "@/components/Cards/CardTarjaQHEEP.vue";
import CardTarjaQHEEPV2 from "@/components/Cards/CardTarjaQHEEPV2.vue";
import CardTarjaTwitterPapoDeSegunda from "@/components/Cards/CardTarjaTwitterPapoDeSegunda.vue";
import CardTarjaLivesGlobo2 from "@/components/Cards/CardTarjaLivesGlobo2.vue";
import CardTarjaCopaAmericaFutebol from "@/components/Cards/CardTarjaCopaAmericaFutebol.vue";
import CardTarjaOlimpiadas from "@/components/CardTarjaOlimpiadas.vue";
import CardTarjaOlimpiadasSporTv from "@/components/CardTarjaOlimpiadasSporTV.vue";
import CardTarjaCronometro from "@/components/Cards/Cronometros/CardTarjaCronometro.vue";
import { apiClient } from "@/services/api";
import CardTarjaEstrelaDaCasa from "@/components/CardTarjaEstrelaDaCasa.vue";
import CardTarjaAudioEDCA from "@/components/CardTarjaAudioEDCA.vue";
import CardTarjaGE from "@/components/Cards/CardTarjaGE.vue";
import CardTarjaPanelaSportv from "@/components/Cards/CardTarjaPanelaSportv.vue";
import CardTarjaFutebolTVFechada from "@/components/Cards/CardTarjaFutebolTVFechada.vue";
import CardTarjaBigPoolDay from "@/components/Cards/CardTarjaBigPoolDay.vue";
import CardTarjaSaiaJusta from "@/components/Cards/midias/Tarjas/SaiaJusta/CardTarjaSaiaJusta.vue";
import CardTarjaTwitterSaiaJusta from "@/components/Cards/midias/Tarjas/SaiaJusta/CardTarjaTwitterSaiaJusta.vue";
import CardTarjaTwitterAngelicaAoVivo from "@/components/Cards/midias/Tarjas/AngelicaAoVivo/CardTarjaTwitterAngelicaAoVivo.vue";
import CardTarjaGETV from "@/components/Cards/CardTarjaGETV.vue";
import CardTarjaInscritosYoutube from "@/components/Cards/CardTarjaInscritosYoutube.vue";
import HlsVideoPlayer from "@/components/HlsVideoPlayer.vue";
import CardTarjaTropaGE from "@/components/Cards/CardTarjaTropaGE.vue";
import CardTarjaTropaGEV2 from "@/components/Cards/CardTarjaTropaGEV2.vue";
import CardTarjaDancaHuck from "@/components/Cards/CardTarjaDancaHuck.vue";
import CardTarjaBlogueirinha from "@/components/Cards/CardTarjaBlogueirinha.vue";
import CardTarjaTVZ from "@/components/Cards/midias/Tarjas/TVZ/CardTarjaTVZ.vue";

const background = {
  pathBgTarcaDasFavelasBlack: require("../assets/bg-tarja-taca-das-favelas2.png"),
  pathBgFutebolGloboEstaduais: require("../assets/tarjas/bg-futebol-globo-estaduais.png"),
  pathBgTarcaDasFavelas: require("../assets/bg-tarja-taca-das-favelas.png"),
  pathBgMundialDeClubesFifa: require("../assets/bg-mundial-de-clubes-fifa.png"),
  pathBGSaoSilvestre: require("../assets/SaoSilvestre/bg-tarja-sao-silvestre-v2.png"),
  pathBGMesacast: require("../assets/bg-mesacast.png"),
  pathBGEliminacao: require("../assets/bg-eliminacao.png"),
  pathBGEliminacaoVertical: require("../assets/bg-eliminacao-vertical.png"),
  pathBGQHEEP: require("../assets/tarjas/tj-twitter-tela-cheia-qheep.png"),
  pathBGQHEEPV2: require("../assets/tarjas/tj-twitter-tela-cheia-qheep-v2.png"),
  pathBGLivesGlobo: require("../assets/tarjas/tj-lives-globo.jpg"),
  pathBGCopaAmericaFutebol: require("../assets/bg-copa-america-futebol.png"),
  pathBGOlimpiadasGlobo: require("../assets/tarjas/tj-olimpiadas-globo.png"),
  pathBGOlimpiadasSporTV: require("../assets/tarjas/tj-olimpiadas-sportv.png"),
  pathBGEstrelaDaCasa: require("../assets/tarjas/bg-estrela-da-casa.png"),
  pathBGEstrelaDaCasaAzulClaro: require("../assets/tarjas/bg-estrela-da-casa-azul-claro.png"),
  pathBGEstrelaDaCasaAzulEscuro: require("../assets/tarjas/bg-estrela-da-casa-azul-escuro.png"),
  pathBGTarjaGe: require("../assets/tarjas/bg-tarja-ge-fullscreen.png"),
  pathBGTarjaFutebolTvAberta: require("../assets/tarjas/bg-tarja-futebol-globo.png"),
  pathBGTarjaFutebolTvFechada: require("../assets/tarjas/bg-tarja-futebol-fechada.jpg"),
  pathBGTarjaGETV: require("../assets/tarjas/GETV/background.png"),
  pathBGTarjaTropaGE: require("../assets/tarjas/tropa-ge/BG.png"),
};

export default {
  components: {
    CardSaoSilvestre,
    CardPanelaco,
    CardTarja: CardTarjaDefault,
    CardTarjaTwitter: CardTarjaDefaultTwitter,
    CardTarjaPapoDeSegunda,
    CardTacaDasFavelas,
    CardTarjaMundialDeClubesFifa,
    CardTarjaMesacast,
    CardTarjaTwitterBBB,
    CardTarjaBBBEliminacao,
    CardTarjaQHEEP,
    CardTarjaQHEEPV2,
    CardTarjaTwitterPapoDeSegunda,
    CardTarjaLivesGlobo2,
    CardTarjaCopaAmericaFutebol,
    CardTarjaCronometro,
    CardTarjaPapoDeSegundaV2,
    CardTarjaSaiaJusta,
    CardTarjaTwitterSaiaJusta,
    CardTarjaTwitterAngelicaAoVivo,
    CardTarjaGETV,
    CardTarjaInscritosYoutube,
    HlsVideoPlayer,
    CardTarjaHexaNeles,
    CardTarjaRadarCopa,
    CardTarjaVoceDecide,
    CardTarjaDancaHuck,
    CardTarjaBlogueirinha,
  },
  data() {
    return {
      codProducao: null,
      idColaboracao: null,
      colabData: null,
      cronometroData: null,
      cameraData: null,
      cacheColabBata: {},
      mountTarja: false,
      producao: {},
      producaoConfigCoresTarja: null,
      cacheProducao: {},
      node_env: null,
      midiaOrientation: null,
      numInscritosYoutube: null,
    };
  },
  mounted() {
    this.node_env = process.env.VUE_APP_ENV;
    // Broadcast display must never scroll: the full-frame tarja can be a few px
    // taller than the browser viewport (100vh + chrome), which shows a scrollbar.
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  },
  beforeDestroy() {
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  },
  computed: {
    viewMode() {
      if (!this.isCronometroMode && this.isCameraMode) {
        return "Camera";
      } else if (this.isCronometroMode && !this.isCameraMode) {
        return "Cronometro";
      }
      return "Midia";
    },
    // A saída do CardTarjaDancaHuck e do CardTarjaBlogueirinha é animada: o
    // <transition> do template segura a desmontagem por 600ms, a mesma
    // duração da animação de saída definida em cada card. Demais cards saem
    // na hora (duração 0), como antes.
    hasTarjaLeaveAnimation() {
      return (
        this.renderMode === CardTarjaDancaHuck ||
        this.renderMode === CardTarjaBlogueirinha
      );
    },
    cardOnView() {
      let cards = [];

      const shouldShowInscritos =
        this.producao?.config_tarja?.flg_exibir_inscritos_youtube || false;
      const hasColaboration = this.colabData && this.colabData.id_colaboracao;

      let inscritosPosition = this.posicaoCardTarja;

      if (shouldShowInscritos && hasColaboration) {
        if (this.posicaoCardTarja === "esquerda") {
          inscritosPosition = "direita";
        } else if (this.posicaoCardTarja === "direita") {
          inscritosPosition = "esquerda";
        }
      }

      if (hasColaboration) {
        cards = this.cardsConfig.filter((card) => card.component === this.renderMode);
      }

      if (shouldShowInscritos) {
        let subscriberCard = this.cardsConfig.find(
          (card) => card.component === CardTarjaInscritosYoutube
        );

        if (subscriberCard) {
          subscriberCard = { ...subscriberCard };
          subscriberCard.options = {
            ...subscriberCard.options,
            posicaoCard: inscritosPosition,
          };
          cards.push(subscriberCard);
        }
      }

      return cards;
    },
    cardsConfig() {
      return [
        {
          id: 1,
          component: CardTarjaQHEEP,
          options: {
            item: this.colabData,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 2,
          component: CardTarjaQHEEPV2,
          options: {
            item: this.colabData,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
            posicaoCard: this.posicaoCardTarja,
          },
        },
        {
          id: 3,
          component: CardTarjaLivesGlobo2,
          options: {
            item: this.colabData,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
            posicaoCard: this.posicaoCardTarja,
          },
        },
        {
          id: 4,
          component: CardTacaDasFavelas,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flg_exibir_uf: this.hideUserState,
            configCores: this.producaoConfigCoresTarja,
          },
        },
        {
          id: 5,
          component: CardTarjaGE,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flg_exibir_uf: this.hideUserState,
            configCores: this.producaoConfigCoresTarja,
          },
        },
        {
          id: 6,
          component: CardTarjaDefaultTwitter,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
          },
        },
        {
          id: 7,
          component: CardTarjaTwitterBBB,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
          },
        },
        {
          id: 8,
          component: CardPanelaco,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            numero: this.producao.dsc_num_telefone,
            flgExibirUf: this.hideUserState,
            isFullScreen: this.isFullScreen,
          },
        },
        {
          id: 9,
          component: CardTarjaPapoDeSegunda,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            flgExibirUf: this.hideUserState,
            isFullScreen: this.isFullScreen,
          },
        },
        {
          id: 10,
          component: CardTarjaPapoDeSegundaV2,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            flgExibirUf: this.hideUserState,
            isFullScreen: this.isFullScreen,
          },
        },
        {
          id: 11,
          component: CardTarjaTwitterPapoDeSegunda,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            flgExibirUf: this.hideUserState,
            configCores: this.producaoConfigCoresTarja,
          },
        },
        {
          id: 12,
          component: CardTarjaMundialDeClubesFifa,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 13,
          component: CardTarjaCopaAmericaFutebol,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 14,
          component: CardTarjaOlimpiadas,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 15,
          component: CardTarjaOlimpiadasSporTv,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 16,
          component: CardSaoSilvestre,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flg_exibir_uf: this.hideUserState,
            configCores: this.producaoConfigCoresTarja,
          },
        },
        {
          id: 17,
          component: CardTarjaMesacast,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 18,
          component: CardTarjaBBBEliminacao,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 19,
          component: CardTarjaEstrelaDaCasa,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 20,
          component: CardTarjaAudioEDCA,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 21,
          component: CardTarjaPanelaSportv,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 22,
          component: CardTarjaFutebolTVFechada,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 23,
          component: CardTarjaBigPoolDay,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flg_exibir_uf: this.hideUserState,
            configCores: this.producaoConfigCoresTarja,
          },
        },
        {
          id: 24,
          component: CardTarjaDefault,
          options: {
            colabData: this.colabData,
            posicaoCard: this.posicaoCardTarja,
          },
        },
        {
          id: 25,
          component: CardTarjaSaiaJusta,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 26,
          component: CardTarjaTwitterSaiaJusta,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 27,
          component: CardTarjaTwitterAngelicaAoVivo,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            flg_exibir_uf: this.hideUserState,
          },
        },
        {
          id: 28,
          component: CardTarjaGETV,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 29,
          component: CardTarjaInscritosYoutube,
          options: {
            numInscritosYoutube: this.numInscritosYoutube,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
          },
        },
        {
          id: 30,
          component: CardTarjaTropaGE,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 31,
          component: CardTarjaTVZ,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 32,
          component: CardTarjaHexaNeles,
          options: {
            colabData: this.colabData,
            posicaoCard: this.posicaoCardTarja,
          },
        },
        {
          id: 33,
          component: CardTarjaRadarCopa,
          options: {
            colabData: this.colabData,
            posicaoCard: this.posicaoCardTarja,
          },
        },
        {
          id: 34,
          component: CardTarjaVoceDecide,
          options: {
            colabData: this.colabData,
            posicaoCard: this.posicaoCardTarja,
          },
        },
        {
          id: 35,
          component: CardTarjaTropaGEV2,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 36,
          component: CardTarjaDancaHuck,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
        {
          id: 37,
          component: CardTarjaBlogueirinha,
          options: {
            item: this.colabData,
            posicaoCard: this.posicaoCardTarja,
            isFullScreen: this.isFullScreen,
            hideUserInfo: this.hideUserInfo,
            flgExibirUf: this.hideUserState,
          },
        },
      ];
    },
    renderMode() {
      if (!this.colabData || !this.colabData.dsc_fonte_colaboracao) {
        return null;
      }

      if ([145, 163].includes(this.codProducao)) {
        return CardTarjaDancaHuck;
      }

      // Blogueirinha assumiu a produção 147 (antes RadarCopa, agora só HML
      // pelo id 138).
      if ([147, 166].includes(this.codProducao)) {
        return CardTarjaBlogueirinha;
      }

      if ([140, 149].includes(this.codProducao)) {
        return CardTarjaVoceDecide;
      }

      if (
        this.colabData.dsc_fonte_colaboracao.toLowerCase() === "twitter" &&
        ![52, 62, 65, 29, 38, 35, 120, 126, 61, 138, 147].includes(this.codProducao)
      ) {
        return CardTarjaDefaultTwitter;
      } else if (this.codProducao === 38) {
        return CardPanelaco;
      } else if (
        [29].includes(this.codProducao) &&
        !["twitter", "threads", "bluesky", "socialcam"].includes(
          this.colabData.dsc_fonte_colaboracao.toLowerCase()
        )
      ) {
        return CardTarjaPapoDeSegunda;
      } else if (
        [29].includes(this.codProducao) &&
        ["socialcam"].includes(this.colabData.dsc_fonte_colaboracao.toLowerCase())
      ) {
        return CardTarjaPapoDeSegundaV2;
      } else if (
        [29].includes(this.codProducao) &&
        ["twitter", "threads", "bluesky"].includes(
          this.colabData.dsc_fonte_colaboracao.toLowerCase()
        )
      ) {
        return CardTarjaTwitterPapoDeSegunda;
      } else if (
        [41, 42, 43, 60, 107].includes(this.codProducao) &&
        this.colabData.dsc_fonte_colaboracao.toLowerCase() !== "twitter"
      ) {
        return CardTacaDasFavelas;
      } else if (
        [50].includes(this.codProducao) &&
        this.colabData.dsc_fonte_colaboracao.toLowerCase() !== "twitter"
      ) {
        return CardTarjaMundialDeClubesFifa;
      } else if (
        [49].includes(this.codProducao) &&
        this.colabData.dsc_fonte_colaboracao.toLowerCase() !== "twitter"
      ) {
        return CardSaoSilvestre;
      } else if (
        this.codProducao === 51 &&
        this.colabData.dsc_fonte_colaboracao.toLowerCase() !== "twitter"
      ) {
        return CardTarjaMesacast;
      } else if (
        [17].includes(this.codProducao) &&
        this.colabData.dsc_fonte_colaboracao.toLowerCase() !== "twitter" &&
        this.isFullScreen
      ) {
        return CardTarjaBBBEliminacao;
      } else if (
        [76].includes(this.codProducao) &&
        this.colabData.dsc_fonte_colaboracao.toLowerCase() !== "twitter" &&
        this.isFullScreen
      ) {
        return CardTarjaEstrelaDaCasa;
      } else if (
        [76].includes(this.codProducao) &&
        this.colabData.dsc_fonte_colaboracao.toLowerCase() !== "twitter" &&
        !this.isFullScreen
      ) {
        return CardTarjaAudioEDCA;
      } else if (
        [17].includes(this.codProducao) &&
        this.colabData.dsc_fonte_colaboracao.toLowerCase() !== "twitter" &&
        !this.isFullScreen
      ) {
        return CardTarjaMesacast;
      } else if (
        this.colabData.dsc_fonte_colaboracao.toLowerCase() === "twitter" &&
        [52].includes(this.codProducao)
      ) {
        return CardTarjaTwitterBBB;
      } else if (
        this.colabData.dsc_fonte_colaboracao.toLowerCase() === "twitter" &&
        [62].includes(this.codProducao)
      ) {
        return CardTarjaQHEEP;
      } else if (
        this.colabData.dsc_fonte_colaboracao.toLowerCase() === "twitter" &&
        [65].includes(this.codProducao)
      ) {
        return CardTarjaQHEEPV2;
      } else if ([69].includes(this.codProducao)) {
        return CardTarjaLivesGlobo2;
      } else if ([70].includes(this.codProducao)) {
        return CardTarjaCopaAmericaFutebol;
      } else if ([74].includes(this.codProducao)) {
        return CardTarjaOlimpiadas;
      } else if ([75].includes(this.codProducao)) {
        return CardTarjaOlimpiadasSporTv;
      } else if ([118].includes(this.codProducao)) {
        return CardTarjaGE;
      } else if (
        [120].includes(this.codProducao) &&
        this.producaoConfigCoresTarja.dsc_nome_config === "Panela SporTV"
      ) {
        return CardTarjaPanelaSportv;
      } else if ([134].includes(this.codProducao)) {
        return CardTarjaGETV;
      } else if ([132].includes(this.codProducao)) {
        return CardTarjaTropaGE;
      } else if ([30, 31].includes(this.codProducao)) {
        return CardTarjaFutebolTVFechada;
      } else if ([123].includes(this.codProducao)) {
        return CardTarjaBigPoolDay;
      } else if (
        [35].includes(this.codProducao) &&
        this.colabData.dsc_fonte_colaboracao.toLowerCase() !== "twitter"
      ) {
        return CardTarjaSaiaJusta;
      } else if (
        this.colabData.dsc_fonte_colaboracao.toLowerCase() === "twitter" &&
        [35].includes(this.codProducao)
      ) {
        return CardTarjaTwitterSaiaJusta;
      } else if ([126].includes(this.codProducao)) {
        return CardTarjaTwitterAngelicaAoVivo;
      } else if ([61].includes(this.codProducao)) {
        return CardTarjaTVZ;
      } else if ([136].includes(this.codProducao)) {
        return CardTarjaTropaGEV2;
      }
      // RadarCopa — cod_producao differs per environment: 138 (HML), 147 (PRD).
      else if ([138, 147].includes(this.codProducao)) {
        return CardTarjaRadarCopa;
      }
      return CardTarjaDefault;
    },
    posicaoCardTarja() {
      const defaultPosition = "esquerda";
      if (this.producao) {
        if (this.isCronometroMode) {
          return this.cronometroData.config_tarja_cronometro.dsc_posicao_tarja;
        }
        return this.producao.config_tarja.dsc_posicao_tarja || defaultPosition;
      }
      return defaultPosition;
    },
    isFullScreen() {
      if (this.producao) {
        if (this.isCronometroMode) {
          return this.cronometroData.config_tarja_cronometro.flg_is_fullscreen;
        }
        return this.producao.config_tarja
          ? this.producao.config_tarja.flg_is_fullscreen
          : false;
      }
      return false;
    },
    hideUserInfo() {
      if (this.producao) {
        return !this.producao.config_tarja
          ? this.producao.config_tarja.flg_display_card_header
          : false;
      }
      return false;
    },
    hideUserState() {
      if (this.producao) {
        return this.producao.config_tarja
          ? this.producao.config_tarja.flg_exibir_uf
          : false;
      }
      return false;
    },
    screenDimensions() {
      return {
        width: this.$vuetify.breakpoint.width,
        height: this.$vuetify.breakpoint.height,
      };
    },
    isVertical() {
      return this.screenDimensions.width < this.screenDimensions.height;
    },
    isCronometroMode() {
      if (this.producao) {
        return this.producao.config_tarja_cronometro
          ? !!this.producao.config_tarja_cronometro.id_cronometro
          : false;
      }
      return false;
    },
    isCameraMode() {
      // check in url query params, if has mode=cam param
      return this.$route.query.mode === "cam";
    },
  },
  async created() {
    if (!this.$store.state.users.isAuthenticated) {
      apiClient.interceptors.request.use(
        (config) => {
          const token = this.$route.query.token || null;

          if (token) {
            config.headers["x-access-token"] = token;
          }
          return config;
        },
        (error) => {
          console.error(error);
          return Promise.reject(error);
        }
      );
    }
    if (
      JSON.parse(localStorage.getItem("@socialcam/selected_option_production")) == null &&
      this.$route.query.cod_producao == null
    ) {
      await this.$router.push({ name: "login" });
      return;
    }
    await this.getFromApi();
    setInterval(this.getFromApi, 1000);
    if (
      this.colabData &&
      this.colabData.url_midia_colaboracao &&
      ["image", "video"].includes(this.colabData.dsc_tipo_midia_colaboracao)
    ) {
      this.getMidiaOrientation();
    }
  },
  methods: {
    async getFromApi() {
      this.codProducao =
        Number(localStorage.getItem("@socialcam/selected_option_production")) ||
        parseInt(this.$route.query.cod_producao) ||
        null;
      await apiClient
        .get(`/listarDadosProducao/${this.codProducao}`)
        .then((response) => {
          if (!this.deepEqual(response.data, this.cacheProducao)) {
            this.producao = response.data.producao;
            this.cacheProducao = response.data.producao;

            if (this.producao.num_inscritos_youtube !== undefined) {
              this.numInscritosYoutube = this.producao.num_inscritos_youtube;
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
      if (this.viewMode === "Midia") {
        await apiClient
          .get(`/listaColaboracaoTarja/${this.codProducao}`)
          .then((response) => {
            if (!this.deepEqual(response.data, this.cacheColabBata)) {
              this.colabData = response.data;
              this.cacheColabBata = response.data;
            }

            const shouldShowInscritos =
              this.producao?.config_tarja?.flg_exibir_inscritos_youtube || false;
            this.mountTarja = !!this.colabData?.id_colaboracao || shouldShowInscritos;
          })
          .catch((error) => {
            console.error(error);
          });
      } else if (this.viewMode === "Cronometro") {
        await apiClient
          .get(`/listarDadosCronometroTarja/${this.codProducao}`)
          .then((response) => {
            if (response.data.cronometro) {
              this.cronometroData = response.data.cronometro;
              this.mountTarja = !!this.cronometroData.id;
            }
          });
      } else if (this.viewMode === "Camera") {
        await apiClient
          .get(`/cameras/getCameraModeradaTarja/${this.codProducao}`)
          .then((response) => {
            this.cameraData = response.data.camera_em_exibicao;
            if (response.data.camera_em_exibicao) {
              this.mountTarja = !!this.cameraData.camera.id;
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    deepEqual(obj1, obj2) {
      return (
        JSON.stringify(obj1) === JSON.stringify(obj2) &&
        JSON.stringify(obj1.config_tarja) === JSON.stringify(obj2.config_tarja)
      );
    },
    getMidiaOrientation() {
      if (this.colabData.url_midia_colaboracao) {
        if (this.colabData.dsc_tipo_midia_colaboracao === "image") {
          const image = new Image();
          image.src = this.colabData.url_midia_colaboracao;
          image.onload = () => {
            this.midiaDimension = { width: image.width, height: image.height };
            this.midiaOrientation =
              image.height > image.width ? "vertical" : "horizontal";
          };
        } else if (this.colabData.dsc_tipo_midia_colaboracao === "video") {
          const createdVideoElement = document.createElement("video");
          createdVideoElement.src = this.colabData.url_midia_colaboracao;
          createdVideoElement.style.visibility = "hidden";
          document.body.appendChild(createdVideoElement);
          createdVideoElement.addEventListener("loadedmetadata", () => {
            this.midiaDimension = {
              width: createdVideoElement.videoWidth,
              height: createdVideoElement.videoHeight,
            };
            this.midiaOrientation =
              createdVideoElement.videoHeight > createdVideoElement.videoWidth
                ? "vertical"
                : "horizontal";
            document.body.removeChild(createdVideoElement);
          });
        }
      }
    },
    getBackgroundColor() {
      return this.isCronometroMode
        ? `background: ${this.producao.config_tarja_cronometro?.dsc_hex_background_chroma || 'transparent'}`
        : this.isFullScreen &&
          this.colabData.dsc_fonte_colaboracao.toLowerCase() !== "twitter" &&
          [6, 38].includes(this.codProducao)
        ? { background: "#f4bc40" }
        : this.isFullScreen &&
          this.renderMode === CardTacaDasFavelas &&
          this.producaoConfigCoresTarja.dsc_nome_config ===
            "Background Preto (Libertadores)"
        ? `background-image: url(${background.pathBgTarcaDasFavelasBlack}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen &&
          this.renderMode === CardTacaDasFavelas &&
          this.producaoConfigCoresTarja.dsc_nome_config === "Background Azul (Padrão)"
        ? `background-image: url(${background.pathBgTarcaDasFavelas}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen &&
          this.renderMode === CardTacaDasFavelas &&
          this.producaoConfigCoresTarja.dsc_nome_config === "Campeonato Estadual"
        ? `background-image: url(${background.pathBgFutebolGloboEstaduais}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen &&
          this.renderMode === CardTacaDasFavelas &&
          this.producaoConfigCoresTarja.dsc_nome_config === "Background Nacional 2025"
        ? `background-image: url(${background.pathBGTarjaFutebolTvAberta}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen && this.renderMode === CardTacaDasFavelas
        ? `background-image: url(${background.pathBgTarcaDasFavelas}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen && this.renderMode === CardTarjaMundialDeClubesFifa
        ? `background-image: url(${background.pathBgMundialDeClubesFifa}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen && this.renderMode === CardSaoSilvestre
        ? `background-image: url(${background.pathBGSaoSilvestre}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen && this.renderMode === CardTarjaMesacast
        ? `background-image: url(${background.pathBGMesacast}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen && this.renderMode === CardTarjaQHEEP
        ? `background-image: url(${background.pathBGQHEEP}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen && this.renderMode === CardTarjaQHEEPV2
        ? `background-image: url(${background.pathBGQHEEPV2}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen && this.renderMode === CardTarjaDefaultTwitter
        ? "background-color: rgba(255, 255, 255, .9); "
        : this.isFullScreen && this.renderMode === CardTarjaLivesGlobo2
        ? `background-image: url(${background.pathBGLivesGlobo}); background-size: cover; background-repeat: no-repeat`
        : !this.isVertical && this.isFullScreen && [17].includes(this.codProducao)
        ? `background-image: url(${background.pathBGEliminacao}); background-size: cover; background-repeat: no-repeat`
        : this.isVertical && this.isFullScreen && [17].includes(this.codProducao)
        ? `background-image: url(${background.pathBGEliminacaoVertical}); background-size: cover; background-repeat: no-repeat`
        : !this.mountTarja && [17].includes(this.codProducao)
        ? `background-image: url(${background.pathBGEliminacao}); background-size: cover; background-repeat: no-repeat`
        : !this.isVertical && this.isFullScreen && [76].includes(this.codProducao)
        ? `background-image: url(${background.pathBGEstrelaDaCasaAzulEscuro}); background-size: cover; background-repeat: no-repeat`
        : this.isVertical && this.isFullScreen && [76].includes(this.codProducao)
        ? `background-image: url(${background.pathBGEstrelaDaCasaAzulEscuro}); background-size: cover; background-repeat: no-repeat`
        : !this.mountTarja && [76].includes(this.codProducao)
        ? `background-image: url(${background.pathBGEstrelaDaCasaAzulEscuro}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen && this.renderMode === CardTarjaCopaAmericaFutebol
        ? `background-image: url(${background.pathBGCopaAmericaFutebol}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen && this.renderMode === CardTarjaOlimpiadas
        ? `background-image: url(${background.pathBGOlimpiadasGlobo}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen && this.renderMode === CardTarjaOlimpiadasSporTv
        ? `background-image: url(${background.pathBGOlimpiadasSporTV}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen && this.renderMode === CardTarjaGE
        ? `background-image: url(${background.pathBGTarjaGe}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen && this.renderMode === CardTarjaGETV
        ? `background-image: url(${background.pathBGTarjaGETV}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen && this.renderMode === CardTarjaTropaGE
        ? `background-image: url(${background.pathBGTarjaTropaGE}); background-size: cover; background-repeat: no-repeat`
        : this.isFullScreen && this.renderMode === CardTarjaDancaHuck
        ? { background: "#000" }
        : this.isFullScreen && this.renderMode === CardTarjaTropaGEV2
        ? { background: "transparent" }
        : this.isFullScreen && this.renderMode === CardTarjaFutebolTVFechada
        ? `background-image: url(${background.pathBGTarjaFutebolTvFechada}); background-size: cover; background-repeat: no-repeat`
        : !this.isVertical &&
          !this.isFullScreen &&
          this.colabData &&
          this.colabData.dsc_tipo_midia_colaboracao === "audio" &&
          [17].includes(this.codProducao)
        ? { background: `${this.producao.config_tarja?.dsc_hex_background_chroma || 'transparent'}` }
        : this.isFullScreen &&
          this.midiaOrientation === "vertical" &&
          [29].includes(this.codProducao)
        ? `background-color: rgb(255, 165, 174)`
        : this.isFullScreen &&
          this.midiaOrientation === "horizontal" &&
          [29].includes(this.codProducao)
        ? `background-color: rgb(147, 38, 17)`
        : { background: `${this.producao.config_tarja?.dsc_hex_background_chroma || 'transparent'}` };
    },
    getBackgroundStyle() {
      if (!this.isFullScreen) return {};

      if (
        this.colabData &&
        this.isFullScreen &&
        this.colabData.dsc_fonte_colaboracao.toLowerCase() !== "twitter" &&
        [6, 38].includes(this.codProducao)
      ) {
        return { background: "#f4bc40" };
      }

      if (this.renderMode === CardTacaDasFavelas) {
        return {
          backgroundImage: `url(${background.pathBgTarcaDasFavelas})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        };
      }

      if (this.renderMode === CardTarjaMundialDeClubesFifa) {
        return {
          backgroundImage: `url(${background.pathBgMundialDeClubesFifa})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        };
      }

      if (this.renderMode === CardSaoSilvestre) {
        return {
          backgroundImage: `url(${background.pathBGSaoSilvestre})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        };
      }

      if (this.renderMode === CardTarjaMesacast) {
        return {
          backgroundImage: `url(${background.pathBGMesacast})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        };
      }

      if (this.renderMode === CardTarjaDefaultTwitter) {
        return { backgroundColor: "rgba(255, 255, 255, .9)" };
      }

      if (this.codProducao === 17) {
        if (!this.mountTarja || (this.isVertical && this.isFullScreen)) {
          return {
            backgroundImage: `url(${background.pathBGEliminacaoVertical})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          };
        } else {
          return {
            backgroundImage: `url(${background.pathBGEliminacao})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          };
        }
      }

      if (
        !this.isVertical &&
        !this.isFullScreen &&
        this.colabData &&
        this.colabData.dsc_tipo_midia_colaboracao === "audio"
      ) {
        return { background: this.producao.config_tarja?.dsc_hex_background_chroma || 'transparent' };
      }

      return { background: this.producao.config_tarja?.dsc_hex_background_chroma || 'transparent' };
    },
  },
  watch: {
    colabData: async function () {
      if (this.producao) {
        this.getBackgroundColor();
      }
      if (
        this.colabData &&
        this.colabData.url_midia_colaboracao &&
        ["image", "video"].includes(this.colabData.dsc_tipo_midia_colaboracao)
      ) {
        this.getMidiaOrientation();
      }
    },
    producao: async function () {
      if (this.producao?.config_tarja?.id_config_cores) {
        await apiClient
          .get(`/getProducaoConfigCoresTarja/${this.producao.cod_producao}`)
          .then((response) => {
            this.producaoConfigCoresTarja = response.data.config_cores
              .filter(
                (config) => config.id === this.producao.config_tarja?.id_config_cores
              )
              .at(0);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden; /* broadcast display never scrolls — clip any tarja overflow (no scrollbar) */
}

.tarjaRow {
  display: grid;
  grid-template-columns: 1fr;
}
</style>
